import { Kb3dModel } from '../decorators/kb3d-decorator';
import { ITransformFeature } from '../kb3d-models';
import { KbVector } from '../primitives/kb-vector';
import { Token } from '../token';
import { eMeshChangeTypes, Feature } from './feature';

@Kb3dModel({
    token: Token.TransformFeature,
})
export class TransformFeature extends Feature implements ITransformFeature {
    static _affectedBy = new Set([eMeshChangeTypes.Transform, eMeshChangeTypes.VertexPositions]);
    static _affects = new Set([eMeshChangeTypes.VertexPositions]);

    scale: KbVector;
}
